export default __webpack_public_path__ + "static/media/chest 1.efaf7e3f.svg";